import { useAppDispatch } from 'app/store';
import { audioByTitleWildCardEffect } from 'app/store/Import/effects';
import {
  postSongAudioEffect,
  retryAudioEffect,
  uploadAudioEffect,
} from 'app/store/SongList/effects';
import { setAudioUploadedAction } from 'app/store/Import/slice';
import { Audio } from 'types/audio';
import { ImportAudio } from '../types';

export const useUploadAudio = () => {
  const dispatch = useAppDispatch();

  const doesAudioExists = ({
    songGuid,
    titleWildcard,
  }: {
    songGuid: string;
    titleWildcard: string;
  }) =>
    dispatch(audioByTitleWildCardEffect({ songGuid, titleWildcard })).unwrap();

  const handleExistingAudio = ({
    songGuid,
    existingAudio,
    file,
  }: {
    existingAudio: Audio;
    file: File;
    songGuid: string;
  }) => {
    if (existingAudio.status === 'READY_FOR_UPLOAD') {
      dispatch(
        retryAudioEffect({
          audio: {
            ...existingAudio,
            file,
          },
          songGuid,
        })
      );
    } else {
      dispatch(
        setAudioUploadedAction({
          audioTitle: existingAudio.title,
          status: 'uploaded',
        })
      );
    }
  };

  const uploadNewAudio = async (
    { audioTitle, file: audioFile }: ImportAudio,
    songGuid?: string
  ) => {
    const audio = await dispatch(
      postSongAudioEffect({
        songGuid,
        audio: {
          fileMeta: {
            title: audioTitle,
          },
          file: audioFile,
        },
      })
    ).unwrap();

    if (audio) {
      dispatch(
        uploadAudioEffect({
          audioFile,
          audio,
        })
      );
    }
  };

  const uploadAudio = async (importAudio: ImportAudio, songGuid?: string) => {
    if (!songGuid) {
      dispatch(
        setAudioUploadedAction({
          audioTitle: importAudio.audioTitle,
          status: 'failed',
        })
      );
      return;
    }

    const { audioTitle, file } = importAudio;
    const existingAudio = await doesAudioExists({
      songGuid,
      titleWildcard: audioTitle,
    });
    if (existingAudio) {
      handleExistingAudio({ existingAudio, file, songGuid });
      return;
    }

    try {
      await uploadNewAudio(importAudio, songGuid);
    } catch (e) {
      dispatch(
        setAudioUploadedAction({
          audioTitle: importAudio.audioTitle,
          status: 'failed',
        })
      );
    }
  };

  return { uploadAudio };
};
